import type { ReactNode } from 'react';

export const symbol_earbuds: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M177-177.04Q120-234.08 120-315v-423q0-42 36-72t78-30q42 0 78 36t36 78q0 46-34 80t-80 34h-54v297q0 57 39 96t96 39q57 0 96-39t39-96v-331q0-80.51 57.05-137.26 57.06-56.74 138-56.74Q726-840 783-783.26q57 56.75 57 137.26v411q0 47-28 81t-74.5 34q-46.5 0-86-34T612-234.5q0-46.5 33.5-80.5t79.5-34h55v-297q0-55.83-39.32-94.92Q701.35-780 645.18-780q-56.18 0-95.68 39.08Q510-701.83 510-646v331q0 80.92-57.05 137.96-57.06 57.04-138 57.04Q234-120 177-177.04ZM180-672h54q21 0 38-16.5t17-37.5q0-21-17-37.5T234-780q-21 0-37.5 16.5T180-726v54Zm545.5 492q21.5 0 37.5-16.5t16-38.5v-54h-54q-21 0-37 16.5t-16 38q0 21.5 16 38t37.5 16.5Zm-1.5-56ZM236-728Z"
		/>
	</svg>
);
